import { style } from "typestyle";
import { colors } from "styles/styles";

export const button = style({
  border: 0,
  background: "transparent",
  fontWeight: 500,
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  textDecoration: "none",
});

export const linkButton = style({
  textDecoration: "none",
});

export const loadingWrapper = style({
  marginLeft: "0.5rem",
});

export const darkblue = style({
  color: colors.hooplaWhite,
  backgroundColor: colors.hooplaDarkBlue,
  boxShadow: "0 2px 2px " + colors.hooplaShadowColor,
});

export const lightblue = style({
  color: colors.hooplaWhite,
  backgroundColor: colors.hooplaBlue,
  boxShadow: "0 2px 2px " + colors.hooplaShadowColor,
});

export const green = style({
  backgroundColor: colors.green_00,
});

export const outlined = style({
  border: `1px solid ${colors.hooplaBorderColor}`,
  backgroundColor: "#F8F8F8",
  color: colors.hooplaTextColor,
});

export const blueOutline = style({
  border: `1px solid ${colors.hooplaDarkBlue}`,
  backgroundColor: "transparent",
  color: colors.hooplaDarkBlue,
});

export const white = style({
  border: `1px solid rgba(0,0,0,0.05)`,
  backgroundColor: "white",
  color: colors.hooplaTextColor,
});

export const small = style({
  fontSize: "14px",
  padding: "4px 12px",
  borderRadius: "20px",
});

export const large = style({
  fontSize: "17px",
  padding: "8px 22px",
  borderRadius: "20px",
});
